// locationSlice.ts

import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
// import {  deleteTeamsData, fetchLocationDataStatus, updateLocationData } from '../../services/locationService';
import { ApiError, DepartmentResponse, TeamsState, UploadDepartmentCoverPayload, UploadDepartmentLogoPayload, createTeamsPayload, updateTeamsPayload } from './departmentTypes';
import { createDepartmentData, fetchDepartmentById, fetchDepartmentData, fetchLocationDataStatus, updateLocationData, uploadDepartmentCoverData, uploadDepartmentLogoData } from '../../services/departmenetService';


export const fetchDepartmentList = createAsyncThunk<
  DepartmentResponse,
  number,
  { rejectValue: string }
>(
  'base/fetchDepartmentList',
  async (baseId, { rejectWithValue }) => {
    try {
      if (baseId === undefined) {
        throw new Error('Base ID is undefined');
      }
      const response = await fetchDepartmentData(baseId);
      return response;
    } catch (err) {
      const error = err as Error;
      return rejectWithValue(error.message || 'Failed to fetch base data');
    }
  }
);


// fetch location by status
export const fetchLocationListStatus = createAsyncThunk<
  DepartmentResponse,
  { baseId: number; status?: string },
  { rejectValue: string }
>(
  'base/fetchLocationListStatus',
  async ({ baseId, status }, { rejectWithValue }) => {
    try {
      const response = await fetchLocationDataStatus(baseId, status);
      return response;
    } catch (err) {
      const error = err as Error;
      return rejectWithValue(error.message || 'Failed to fetch base data');
    }
  }
);


// create teams 
export const createDepartment = createAsyncThunk<DepartmentResponse, { payload: createTeamsPayload; userId: number },
  { rejectValue: string }
>(
  'base/createDepartment',
  async ({ payload, userId }, { rejectWithValue }) => {
    try {
      const response = await createDepartmentData(payload, userId);
      return response;
    } catch (err) {
      const error = err as any;
      return rejectWithValue(error.response?.data?.data?.error || 'Failed to invite member');
    }
  }
);

// fetch department by id 
export const fetchDepartmentByIdData = createAsyncThunk<DepartmentResponse, { userId: number; id: number }, { rejectValue: string }>(
  'base/fetchDepartmentByIdData',
  async ({ userId, id }, { rejectWithValue }) => {
    try {
      const response = await fetchDepartmentById(userId, id);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch department');
    }
  }
);

export const uploadDepartmentCover = createAsyncThunk<DepartmentResponse, { payload: UploadDepartmentCoverPayload; userId: number, departmentId: number }, { rejectValue: string }>(
  'base/uploadDepartmentCover',
  async ({ payload, userId, departmentId }, { rejectWithValue }) => {
    try {
      if (!payload.image) {
        return rejectWithValue('Image is required');
      }
      const response = await uploadDepartmentCoverData(payload, userId, departmentId);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to upload base cover');
    }
  }
);


export const uploadDepartmentLogo = createAsyncThunk<DepartmentResponse, { payload: UploadDepartmentLogoPayload; userId: number, departmentId: number }, { rejectValue: string }>(
  'base/uploadDepartmentLogo',
  async ({ payload, userId, departmentId }, { rejectWithValue }) => {
    try {
      if (!payload.image) {
        return rejectWithValue('Image is required');
      }
      const response = await uploadDepartmentLogoData(payload, userId, departmentId);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to upload base cover');
    }
  }
);
// update teams
export const updateLocation = createAsyncThunk<DepartmentResponse, { payload: updateTeamsPayload; userId: number,  departmentId: number },
  { rejectValue: string }
>(
  'base/updateLocation',
  async ({ payload, userId, departmentId }, { rejectWithValue }) => {
    try {
      const response = await updateLocationData(userId, departmentId,  payload);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to invite member');
    }
  }
);

// // delete teams

// export const deleteTeams = createAsyncThunk<DepartmentResponse, { userId: number; id: number }, { rejectValue: string }>(
//   'base/deleteTeams',
//   async ({ userId, id }, { rejectWithValue }) => {
//     try {
//       // Ensure the parameters are in the correct order
//       const response = await deleteTeamsData(userId, id);
//       return response;
//     } catch (err) {
//       const error = err as ApiError;
//       return rejectWithValue(error.response?.data?.message || 'Failed to delete team');
//     }
//   }
// );




const initialState: TeamsState = {
  locationDetails: null,
  locationStatus: 'idle',
  locationStatusError: null,
  createTeamsStatus: 'idle',
  createTeamsError: null,
  createTeamsData: null,
  locationByIdDetails: null,
  locationByIdStatus: 'idle',
  locationStatusByIdError: null,
  updateStatus: 'idle',
  updateError: null,
  uploadStatus: 'idle',
  uploadError: null,
  uploadLogoStatus: 'idle',
  uploadLogoError: null,




  /////////////////

  updateTeamsStatus: 'idle',
  updateTeamsError: null,
  updateTeamsData: null,
  deleteTeamsStatus: 'idle',
  deleteTeamsError: null,
  fetchTeamsByIdStatus: 'idle',
  fetchTeamsByIdError: null,
  fetchTeamsByIdData: null,
  baseMemberInviteStatus: 'idle',
  baseMemberInviteError: null,
  baseMemberInviteData: null,
  locationDetails1: null,
  locationStatus1: 'idle',
  locationStatusError1: null,

};

const locationSlice = createSlice({
  name: 'teams',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDepartmentList.pending, (state) => {
        state.locationStatus = 'loading';
      })
      .addCase(fetchDepartmentList.fulfilled, (state, action: PayloadAction<DepartmentResponse>) => {
        state.locationStatus = 'succeeded';
        state.locationDetails = action.payload.data;
        // localStorage.setItem('baseDepartmentData', JSON.stringify(action.payload));
      })
      .addCase(fetchDepartmentList.rejected, (state, action) => {
        state.locationStatus = 'failed';
        state.locationStatusError = action.payload || 'Failed to fetch boards';
      })
      .addCase(createDepartment.pending, (state) => {
        state.createTeamsStatus = 'loading';
      })
      .addCase(createDepartment.fulfilled, (state, action: PayloadAction<DepartmentResponse>) => {
        state.createTeamsStatus = 'succeeded';
        state.createTeamsData = action.payload;
      })
      .addCase(createDepartment.rejected, (state, action) => {
        state.createTeamsStatus = 'failed';
        state.createTeamsError = action.payload || 'Failed to invite member';
      })
      .addCase(fetchDepartmentByIdData.pending, (state) => {
        state.fetchTeamsByIdStatus = 'loading';
      })
      .addCase(fetchDepartmentByIdData.fulfilled, (state, action: PayloadAction<DepartmentResponse>) => {
        state.fetchTeamsByIdStatus = 'succeeded';
        state.fetchTeamsByIdData = action.payload.data;
      })
      .addCase(fetchDepartmentByIdData.rejected, (state, action) => {
        state.fetchTeamsByIdStatus = 'failed';
        state.fetchTeamsByIdError = action.payload || 'Failed to invite member';
      })
      .addCase(uploadDepartmentCover.pending, (state) => {
        state.uploadStatus = 'loading';
      })
      .addCase(uploadDepartmentCover.fulfilled, (state, action: PayloadAction<DepartmentResponse>) => {
        state.uploadStatus = 'succeeded';
      })
      .addCase(uploadDepartmentCover.rejected, (state, action) => {
        state.uploadStatus = 'failed';
        state.uploadError = action.payload || 'Upload failed';
      })
      .addCase(uploadDepartmentLogo.pending, (state) => {
        state.uploadLogoStatus = 'loading';
      })
      .addCase(uploadDepartmentLogo.fulfilled, (state, action: PayloadAction<DepartmentResponse>) => {
        state.uploadLogoStatus = 'succeeded';
      })
      .addCase(uploadDepartmentLogo.rejected, (state, action) => {
        state.uploadLogoStatus = 'failed';
        state.uploadLogoError = action.payload || 'Upload failed';
      })
    // .addCase(updateLocation.pending, (state) => {
    //   state.updateTeamsStatus = 'loading';
    // })
    // .addCase(updateLocation.fulfilled, (state, action: PayloadAction<DepartmentResponse>) => {
    //   state.updateTeamsStatus = 'succeeded';
    //   state.updateTeamsData = action.payload;
    // })
    // .addCase(updateLocation.rejected, (state, action) => {
    //   state.updateTeamsStatus = 'failed';
    //   state.updateTeamsError = action.payload || 'Failed to invite member';
    // })
    // .addCase(deleteTeams.pending, (state) => {
    //   state.deleteTeamsStatus = 'loading';
    // })
    // .addCase(deleteTeams.fulfilled, (state, action: PayloadAction<DepartmentResponse>) => {
    //   state.deleteTeamsStatus = 'succeeded';
    //   state.updateTeamsData = action.payload;
    // })
    // .addCase(deleteTeams.rejected, (state, action) => {
    //   state.deleteTeamsStatus = 'failed';
    //   state.deleteTeamsError = action.payload || 'Failed to invite member';
    // })
    // .addCase(fetchLocationListStatus.pending, (state) => {
    //   state.locationStatus1 = 'loading';
    // })
    // .addCase(fetchLocationListStatus.fulfilled, (state, action: PayloadAction<DepartmentResponse>) => {
    //   state.locationStatus1 = 'succeeded';
    //   state.locationDetails1 = action.payload.data;
    //   // localStorage.setItem('baseLocationData', JSON.stringify(action.payload));
    // })
    // .addCase(fetchLocationListStatus.rejected, (state, action) => {
    //   state.locationStatus1 = 'failed';
    //   state.locationStatusError1 = action.payload || 'Failed to fetch boards';
    // })
  }
});

export default locationSlice.reducer;

